import { InfoCard } from "@myaccount/_components/info-card";
import { useI18n } from "@wojo/localization";
import { Button, Text } from "@wojo/ui";
import { useId } from "react";
import Link from "next/link";

export const NoBookingsInfoCard: React.FC = () => {
    const headingId = useId();

    const i18n = useI18n("account").account.myGroupMembers.noBookingsInfoCard;
    return (
        <section
            aria-labelledby={headingId}
            style={{
                paddingTop: "var(--g-spacing-xl)",
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            <Text.Heading
                id={headingId}
                order="3"
                tag="h2"
                style={{ paddingBottom: "var(--g-spacing-md)" }}
            >
                {i18n.heading.l()}
            </Text.Heading>
            <InfoCard
                graphic={{
                    lightModeSrc: i18n.textCardIconLight.l(),
                    darkModeSrc: i18n.textCardIconDark.l(),
                    size: {
                        width: 64,
                        height: 64,
                    },
                }}
                heading={
                    <Text.Heading
                        order="3"
                        tag="h2"
                        style={{
                            color: "currentColor",
                            paddingTop: "var(--g-spacing-md)",
                        }}
                    >
                        {i18n.textCardTitle.l()}
                    </Text.Heading>
                }
            >
                <Text.Body
                    style={{
                        color: "currentColor",
                        padding: "var(--g-spacing-sm) 0 var(--g-spacing-md) 0",
                    }}
                >
                    {i18n.textCardBody.l()}
                </Text.Body>
                <Button
                    palette="info"
                    target="_blank"
                    href={i18n.textCardButtonLink.l()}
                    tag={Link}
                >
                    {i18n.textCardButton.l()}
                </Button>
            </InfoCard>
        </section>
    );
};
